export type UsageReason =
  | "self-service-analytics"
  | "embedding"
  | "both"
  | "not-sure";
